import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

//删除部门
export const requestBmDel = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/deldepartment`, params: params });
    return res.data;
};

//上级部门
export const requestBmList = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/departmentall`, params: params });
    return res.data;
};

//添加部门
export const requestBmAdd = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/editdepartment`, params: params });
    return res.data;
};

// 部门详情
export const requestBmDetails = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/finddepartmentbyid`, params: params });
    return res.data;
};

//部门下人员列表
export const requestBmUser = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/departmentuserbydepartmentid`, params: params });
    return res.data;
};

//部门下人员删除
export const requestBmUserDel = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/deldepartmentuser`, params: params });
    return res.data;
};

//部门人员添加
export const requestBmUserAdd = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/adddepartmentuser`, params: params });
    return res.data;
};

//选择部门
export const requestChooseBm = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/getdepartmentanduser`, params: params });
    return res.data;
};

//权限回显
export const requestBmhx = async params => {
    const res = await axios({ method: 'post', url: `${base}/department/getdepartmentstringlist`, params: params });
    return res.data;
};

